module.exports = __webpack_public_path__ + "static/img/strona_004.e921d19c.jpg";